import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { AppContext } from 'commons-ui';
import { ContentPropsT, FORM_FIELD_KEYS } from './constants';
import { FORM_FIELD_CONFIG } from './formConfig';
import useUserService from '../../../userManagement/utils/useService';
import { RegistrationFilters } from '../constants';

const useContent = (props: ContentPropsT) => {
	const { handleFilterSubmit, onClose } = props;

	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const { getManagerOptions, getDepartmentOptions, getDesignationOptions, getRoleNameTempOptions } = useUserService();
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.MANAGER_NAME].setRenderProps({ getOptions: getManagerOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.DEPARTMENT].setRenderProps({ getOptions: getDepartmentOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.DESIGNATION].setRenderProps({ getOptions: getDesignationOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.ROLE_NAME_TEMP].setRenderProps({ getOptions: getRoleNameTempOptions });
	const history = useHistory();
	const location = useLocation();

	const handleFormSubmit = async (submittedData: RegistrationFilters) => {
		try {
			setShowLoader(true);
			const { managerName, department, designation, roleNameTemp, email } = submittedData;
			handleFilterSubmit({ managerName, department, designation, roleNameTemp, email });
			const querySearchParams = new URLSearchParams(location.search);
			history.replace({ pathname: location.pathname, search: querySearchParams.toString() });
			setShowLoader(false);
		} catch (error) {
			showAlert('Error in fetching user', { type: 'error' });
		} finally {
			onClose();
		}
	};

	const handleFormCancel = () => {
		onClose();
	};

	return {
		showLoader,
		setShowLoader,
		handleFormSubmit,
		handleFormCancel
	};
};

export default useContent;
